"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "azzate": {
    "919f22b9": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-fiori": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1191ad7": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-fornace": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd1c1605": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-galgino": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6761893b": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-maccana": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "866f2711": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-prada": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb0359cc": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38191a05": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "fontanone": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01ebecaf": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "la-favorita": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf2de06b": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "molino-valciasca": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cc8885f8": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "pratonuovo": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42a2152c": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "0d10db54",
      "slug": "azzate",
      "name": "Azzate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;